// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'

import store from './store'
import VuePaginate from 'vue-paginate'
import JsonExcel from 'vue-json-excel'

Vue.component('downloadExcel', JsonExcel)

import contextMenu from "vue-context-menu";

Vue.component('contextMenu', contextMenu)

import vSelect from 'vue-select'

Vue.component('v-select', vSelect)

import VueToastr2 from 'vue-toastr-2'
import 'vue-toastr-2/dist/vue-toastr-2.min.css'

window.toastr = require('toastr')
Vue.use(VueToastr2)

import VueSocketio from 'vue-socket.io'

Vue.use(new VueSocketio({
    debug: true,
    connection: process.env.VUE_APP_SOCKET
  })
)
Vue.use(VuePaginate)

import DatePicker from 'vue2-datepicker'

Vue.component('date-picker', DatePicker)

import moment from 'moment'

Vue.filter('formatDate', function (value) {
  if (value) {
    let date = moment(String(value))
    if (date.isValid()) {
      return date.format('DD/MM/YYYY')
    }
    return ""
  }
})

Vue.filter('formatHour', function (value) {
  if (value) {
    let hour = moment(String(value))
    if (hour.isValid()) {
      return hour.format('HH:mm')
    }
    return ""
  }
})

Vue.filter('formatDateTime', function (value) {
  if (value) {
    let hour = moment(String(value))
    if (hour.isValid()) {
      return hour.format('DD/MM/YYYY HH:mm')
    }
    return ""
  }
})

Vue.filter('formatDateTimeAux', function (value) {
  if (value) {
    let hour = moment(String(value))
    moment.locale('es');
    if (hour.isValid()) {
      return hour.format('MMMM YYYY')
    }
    return ""
  }
})

Vue.filter('UpperCaseAux', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.toUpperCase()
})

import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
    libraries: 'places'
  }
})

// todo
// cssVars()

Vue.use(BootstrapVue)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})
